import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class BeaconLinkController extends BridgeComponent {
  static component = "intercom";
  static values = { article: String }

  open(e) {
    e.preventDefault();

    logEvent("Get Help - Opened Intercom", { location: "Message", subject: this.element.getAttribute('data-beacon-subject') });
    
    this.send("present", () => {
    });
  }
}
